import developmentReview from './developmentReview'
import type { IMerchTemplate } from './IMerchTemplate'
import standard from './standard'
import techSheet from './techSheet'
import uaStandard from './uaStandard'
import visualLineBuilder from './visualLineBuilder'
import GraphicTeeTechSheet from './graphicTeeTechSheetMerch'
import ApparelTechSheet from './apparelTechSheetMerch'
import FootwearTechSheet from './footwearTechSheetMerch'
import AccessoriesTechSheet from './accessoriesTechSheetMerch'
import OnTemplate from './onTemplate'

// TODO: Might need to load them dynamically

const templates: Record<number, IMerchTemplate> = {}
// templates[browseByAttribute.id] = browseByAttribute
templates[techSheet.id] = techSheet
templates[uaStandard.id] = uaStandard
templates[developmentReview.id] = developmentReview
templates[standard.id] = standard
templates[visualLineBuilder.id] = visualLineBuilder
templates[GraphicTeeTechSheet.id] = GraphicTeeTechSheet
templates[ApparelTechSheet.id] = ApparelTechSheet
templates[FootwearTechSheet.id] = FootwearTechSheet
templates[AccessoriesTechSheet.id] = AccessoriesTechSheet
templates[OnTemplate.id] = OnTemplate

export default templates
